
import dev from './dev';

const ret = {
    baseUrl: dev() ? 'http://localhost/' : ''
}

export default ret